import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { OvertimeTypes, Tournament, TournamentRoundTeam, TournamentTeam } from '@mtgame/core';
import { getHeaderHeight } from '@utils/layout';
import { getTeamPageRoute } from '@config/routes';

@Component({
  selector: 'mtg-hockey-standings',
  templateUrl: './hockey-standings.component.html',
  styleUrls: ['./hockey-standings.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HockeyStandingsComponent {
  @Input()
  tournament: Tournament;
  @Input()
  teams: TournamentRoundTeam[];
  headerHeight = getHeaderHeight();
  overtimeTypes = OvertimeTypes;

  getTeamPageRoute(teamId: number): string[] {
    return getTeamPageRoute(teamId);
  }
}
